import React from 'react';
import { makersExperience } from '@fiverr-private/logo_maker_analytics';
import monitor from '../../../service/bigquery';
import { type TrackingData } from '../../../shared/lib/getTrackingData';
import topLevelSource from '../../../shared/storage/topLevelSource';
import { UserAgentContext } from '../../../shared/components/UserAgentContext';
import { useOnceBeforeRender } from '../../../shared/hooks';
import type { LogoMakerIntegration } from '../../../shared/types';
import { type UserAgentData } from '../../../shared/lib/getUserAgent';
import { INTEGRATIONS_METADATA } from '../../../shared/constants';
import IntegrationLandingPage from '../../components/IntegrationLandingPage/IntegrationLandingPage';

const { fromBoost, pageType } = makersExperience.integrationLandingPage.store;

interface ClientIntegrationLandingPagePageProps {
  userAgent: UserAgentData;
  industriesTags: {
    tagName: string;
    tagId: string;
    tagType: string;
  }[];
  integration: LogoMakerIntegration;
  tracking: TrackingData;
  mixpanel: {
    fromBoost: 0 | 1;
  };
}

export default function ClientIntegrationLandingPagePage({
  userAgent,
  industriesTags,
  integration,
  tracking,
  mixpanel,
}: ClientIntegrationLandingPagePageProps) {
  useOnceBeforeRender(() => {
    fromBoost.setData(mixpanel.fromBoost);
    pageType.setData(INTEGRATIONS_METADATA[integration].TOP_LEVEL_SOURCE);

    monitor.initialize(tracking);

    // Set mark in the localStorage to mark a user as they came from the Makers landing page
    topLevelSource.setTopLevelSourceInStorage(INTEGRATIONS_METADATA[integration].TOP_LEVEL_SOURCE);
  });

  return (
    <UserAgentContext.Provider value={userAgent}>
      <IntegrationLandingPage
        pageCtxId={tracking.pageCtxId}
        integration={integration}
        industriesTags={industriesTags}
      />
    </UserAgentContext.Provider>
  );
}
